import { Component, Input, OnInit } from '@angular/core';
import { MyUtils } from 'src/app/services/my-utils.service';

@Component({
  selector: 'app-loader-widget',
  templateUrl: './loader-widget.component.html',
  styleUrls: ['./loader-widget.component.css']
})
export class LoaderWidgetComponent implements OnInit {

  @Input() isLoader? = false;
  constructor(public utils: MyUtils) { }

  ngOnInit() {
    
  }

}
